type AttributeValueMappings = {
  cardIcons?: Record<string, string>;
  names: Record<string, string>;
  productImages?: Record<string, string>;
  softcoverProductImages?: Record<string, string>;
  hardcoverProductImages?: Record<string, string>;
};
export const ATTRIBUTE_VALUE_MAPPINGS_BY_KEY: Record<string, AttributeValueMappings> = {
  coverType: {
    names: {
      HCIW: "Hardcover, Image Wrap",
      SC: "Softcover, Image Wrap",
    },
    productImages: {
      HCIW: "/assets/images/cover-types/product-images/hardcover-imagewrap.png",
      SC: "/assets/images/cover-types/product-images/softcover-imagewrap.png",
    },
  },
  coverFinish: {
    names: {
      GLS: "Gloss",
      MAT: "Matte",
    },
    softcoverProductImages: {
      GLS: "/assets/images/cover-finishes/product-images/softcover/gloss.png",
      MAT: "/assets/images/cover-finishes/product-images/softcover/matte.png",
    },
    hardcoverProductImages: {
      GLS: "/assets/images/cover-finishes/product-images/hardcover/gloss.png",
      MAT: "/assets/images/cover-finishes/product-images/hardcover/matte.png",
    },
  },
  bindType: {
    names: {
      STD: "Glue Bound (Standard)",
    },
    softcoverProductImages: {
      STD: "/assets/images/bind-types/product-images/softcover/glue.png",
    },
    hardcoverProductImages: {
      STD: "/assets/images/bind-types/product-images/hardcover/glue.png",
    },
  },
  textStock: {
    names: {
      "100T": "100 lbs Gloss Finish",
    },
    productImages: {
      "100T": "/assets/images/paper-types/product-images/100_gloss.png",
    },
  },
  dimensions: {
    cardIcons: {
      "7.75x9.75IN": "/assets/images/book-orientation/book-sizes/orientation_portrait.png",
      "8x10IN": "/assets/images/book-orientation/book-sizes/orientation_portrait.png",
      "8x8IN": "/assets/images/book-orientation/book-sizes/orientation_square.png",
      "8.25x10.75IN": "/assets/images/book-orientation/book-sizes/orientation_portrait.png",
      "8.5x11IN": "/assets/images/book-orientation/book-sizes/orientation_portrait.png",
      "9x6IN": "/assets/images/book-orientation/book-sizes/orientation_landscape.png",
      "10.75x8.25IN": "/assets/images/book-orientation/book-sizes/orientation_landscape.png",
      "11x8.5IN": "/assets/images/book-orientation/book-sizes/orientation_landscape.png",
      "11.75x11.75IN": "/assets/images/book-orientation/book-sizes/orientation_square.png",
      "12x12IN": "/assets/images/book-orientation/book-sizes/orientation_square.png",
    },
    names: {
      "7.75x9.75IN": "7.75x9.75 in",
      "8x10IN": "8x10 in",
      "8x8IN": "8x8 in",
      "8.25x10.75IN": "8.25x10.75 in",
      "8.5x11IN": "8.5x11 in",
      "9x6IN": "9x6 in",
      "10.75x8.25IN": "10.75x8.25 in",
      "11x8.5IN": "11x8.5 in",
      "11.75x11.75IN": "11.75x11.75 in",
      "12x12IN": "12x12 in",
    },
  },
  orientation: {
    cardIcons: {
      LANDSCAPE: "/assets/images/book-orientation/book-sizes/orientation_landscape.png",
      PORTRAIT: "/assets/images/book-orientation/book-sizes/orientation_portrait.png",
      SQUARE: "/assets/images/book-orientation/book-sizes/orientation_square.png",
    },
    names: {
      LANDSCAPE: "Landscape",
      PORTRAIT: "Portrait",
      SQUARE: "Square",
    },
  },
};

export function getCardIconPath(attributeKey: string, attributeValue: string): string | undefined {
  return ATTRIBUTE_VALUE_MAPPINGS_BY_KEY[attributeKey]?.cardIcons?.[attributeValue];
}

export function getDisplayName(attributeKey: string, attributeValue: string): string | undefined {
  return ATTRIBUTE_VALUE_MAPPINGS_BY_KEY[attributeKey]?.names[attributeValue];
}

export function getProductImage(attributeKey: string, attributeValue: string): string | undefined {
  return ATTRIBUTE_VALUE_MAPPINGS_BY_KEY[attributeKey]?.productImages?.[attributeValue];
}

export function getSoftcoverProductImage(attributeKey: string, attributeValue: string): string | undefined {
  return ATTRIBUTE_VALUE_MAPPINGS_BY_KEY[attributeKey]?.softcoverProductImages?.[attributeValue];
}

export function getHardcoverProductImage(attributeKey: string, attributeValue: string): string | undefined {
  return ATTRIBUTE_VALUE_MAPPINGS_BY_KEY[attributeKey]?.hardcoverProductImages?.[attributeValue];
}
